import { render, staticRenderFns } from "./u-file-input-solo-rounded.vue?vue&type=template&id=0ca6d819&scoped=true&"
import script from "./u-file-input-solo-rounded.vue?vue&type=script&lang=js&"
export * from "./u-file-input-solo-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca6d819",
  null
  
)

export default component.exports